export const namespace = 'canalplus.block.javascript.html';
export { default as Component } from './components/Html';
export { default as propsFormatter } from './propsFormatter';
